import React from "react";
import {
  useAdminUpdateOrganizationMutation,
  AdminUpdateOrganizationMutation,
  useAdminOrganizationQuery,
} from "@apollo/ops";
import { MessageSeverity } from "@shared/types/Severity";
import { toast } from "@utilities/toast";
import { DistributorForm, DistributorFormData } from "./DistributorForm";

type UpdateDistributorProps = {
  distributorId: number;
  onUpdate: (data: AdminUpdateOrganizationMutation) => void;
};

export function UpdateDistributor({
  distributorId,
  onUpdate,
}: UpdateDistributorProps) {
  const { data } = useAdminOrganizationQuery({
    variables: {
      id: distributorId,
    },
  });

  const [updateOrganization] = useAdminUpdateOrganizationMutation();

  if (!data) {
    return null;
  }

  const handleSubmit = async ({ name }: DistributorFormData) => {
    try {
      const { data } = await updateOrganization({
        variables: {
          id: distributorId,
          name,
        },
      });

      if (data && onUpdate) {
        onUpdate(data);
      }

      toast.current?.show({
        severity: MessageSeverity.success,
        summary: "",
        detail: `Update distributor ${name}`,
      });
    } catch (error) {
      // TODO handle other error case
      if (error.message) {
        toast.current?.show({
          severity: MessageSeverity.error,
          summary: "",
          detail: error.message,
        });
      }
    }
  };

  return (
    <DistributorForm
      submitText="Update"
      onSubmit={handleSubmit}
      defaultValues={data.organization}
    />
  );
}
